import apiClient from "../apiClient";
import API_ENDPOINTS from "../endpoints";

const configureService = {
  getAdvertisers: (params) =>
    apiClient.get(API_ENDPOINTS.GET_ADVERTISERS, { params }),
  //   getUserById: (id) => apiClient.get(`${API_ENDPOINTS.USERS}/${id}`),
  createAdvertiser: (formData) => {
    return apiClient.post(API_ENDPOINTS.CREATE_ADVERSTISER, formData);
  },
  getEventsList: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_EVENTS_LIST, { params });
  },
  getCampaignIdList: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_CAMPAIGN_ID_LIST, { params });
  },
  getReportData: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_REPORT_DATA, { params });
  },
  getInsightsData: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_INSIGHTS_DATA, { params });
  },
  generateInsights: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_GENERATED_INSIGHTS, { params });
  },
  getRestoreInsights: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_RESTORE_INSIGHTS, { params });
  },
  getCountryList: () => {
    return apiClient.get(API_ENDPOINTS.GET_COUNTRY_LIST);
  },
  getMetricList: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_METRIC_LIST, { params });
  },
  getCreativeInsightsMeta: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_CREATIVE_INSIGHTS_META, { params });
  },
  getAdvertiserData: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_ADVERTISER_DATA, { params });
  },
  addAdvertiserData: (body) => {
    return apiClient.post(API_ENDPOINTS.ADD_ADVERTISER_DATA, body);
  },
  addCreativeInsights: (body) => {
    return apiClient.post(API_ENDPOINTS.ADD_CREATIVE_INSIGHTS, body);
  },
  editAdvertiser: (body) => {
    return apiClient.patch(API_ENDPOINTS.EDIT_ADVERSTISER, body);
  },
  editAdvertiserData: (body) => {
    return apiClient.patch(API_ENDPOINTS.EDIT_ADVERTISER_DATA, body);
  },
  editCreativeInsights: (body) => {
    return apiClient.patch(API_ENDPOINTS.EDIT_CREATIVE_INSIGHTS, body);
  },
  addAdvertiserReport: (body) => {
    return apiClient.post(API_ENDPOINTS.ADD_ADVERTISER_REPORT, body);
  },
  editAdvertiserReportData: (body) => {
    return apiClient.patch(API_ENDPOINTS.EDIT_ADVERTISER_REPORT, body);
  },
  addAdvertiserInsights: (formData) => {
    return apiClient.post(API_ENDPOINTS.ADD_ADVERTISER_INSIGHTS, formData);
  },
  editAdvertiserInsights: (body) => {
    return apiClient.patch(API_ENDPOINTS.EDIT_ADVERTISER_INSIGHTS, body);
  },
  activeDeactiveAdvertiser: (body) => {
    return apiClient.patch(API_ENDPOINTS.ACTIVE_DEACTIVE_ADVERTISER, body);
  },
  getGoogleConfiguration: (params) => {
    return apiClient.get(API_ENDPOINTS.GET_GOOGLE_CONFIG, { params });
  },
  //   updateUser: (id, data) => apiClient.put(`${API_ENDPOINTS.USERS}/${id}`, data),
  //   deleteUser: (id) => apiClient.delete(`${API_ENDPOINTS.USERS}/${id}`),
};

export default configureService;
